<script setup lang="ts">
import { computed } from 'vue'
import { isNotEmpty } from '@/utils/util'

const props = defineProps({
  msg: {
    type: String,
    default: ''
  }
})

const msgComp = computed(() => props.msg)
</script>
<template>
  <!-- outer layout -->
  <div h-full w-full flex flex-col px-4 mt-6>
    <div w-full class="h-4/6" min-h-96 rounded-2 flex="~ col" items-center justify-center>
      <div flex-l-center text-third>
        <div i-solar:cloud-cross-outline text-4xl></div>
        <p v-if="isNotEmpty(msgComp)" my-3>{{ msgComp }}</p>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
